export default __webpack_public_path__ + "static/media/2.b995612f.jpg";